/**
 * RFC-003 §6.1：拉取组织成员池，用于项目邀请弹窗。
 */
import { useQuery } from '@tanstack/react-query';
import { orgMembersApi } from '@/services/api/org-members';

export const availableOrgMembersKeys = {
  all: ['org-members-available-for-project'] as const,
  forProject: (orgId: string, projectId: string, positionIds: string[] = []) =>
    [...availableOrgMembersKeys.all, orgId, projectId, positionIds.join(',')] as const,
};

/**
 * 查询可邀请进入某项目的组织成员清单（含 `alreadyInProject` 标记）。
 *
 * @param orgId  项目所属组织 ID；为空时查询自动禁用。
 * @param projectId 目标项目 ID；为空时查询自动禁用。
 * @param enabled 外部控制开关，默认 `true`。
 */
export function useAvailableOrgMembersForProject(
  orgId: string | null | undefined,
  projectId: string | null | undefined,
  enabled = true,
  positionIds: string[] = []
) {
  return useQuery({
    queryKey: availableOrgMembersKeys.forProject(orgId ?? '', projectId ?? '', positionIds),
    queryFn: () => orgMembersApi.listAvailableForProject(orgId!, projectId!, positionIds),
    enabled: enabled && !!orgId && !!projectId,
  });
}
